<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal v-if="showModal"
           size="medium"
           id="customerGroupFileModal"
           :title="modalTitle">

        <template v-slot:body>
            <div class="container-fluid-grid">

                <div class="form-row">
                    <div class="col-12 form-group">
                        <label for="customerGroupFileId" class="required">Grupo</label>
                        <select id="customerGroupFileId"
                                v-model="customer_group_id"
                                :disabled="modalMode === 'block_customer_group'"
                                @change="changeCustomerGroup"
                                class="form-control form-control-sm">
                            <option :value="null">[SELECIONE]</option>
                            <option v-for="cg in customer_groups" :key="cg.id" :value="cg.id">{{cg.name}} ({{cg.count}})</option>
                        </select>
                    </div>
                    <div class="col-12 form-group">
                        <label>&nbsp;</label>
                        <FileUpload :url="`/v1/customer_group_files/upload_file/${customer_group_id}`"
                                    :file-formats="accept_files"
                                    :disabled="customer_group_id === null"
                                    @onFileUploaded="fileUploaded"
                                    multiple="true"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <table v-if="files.length > 0" class="table table-striped table-sm">
                            <thead class="thead-dark thead-center">
                            <tr>
                                <th>Arquivo</th>
                                <th style="width: 100px">Tamanho</th>
                                <th style="width: 130px">Data</th>
                                <th style="width: 30px"/>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="f in files"
                                :key="f.id">
                                <td class="ellipsis">
                                    <a href="javascript:void(0)"
                                       target="_blank"
                                       @click="download(f.id)"
                                       class="link-theme">{{f.name}}</a>
                                </td>
                                <td class="ellipsis t-r">{{f.size_text}}</td>
                                <td class="ellipsis t-c" :title="f.distance">{{f.created_at | formatDateHourMin}}</td>
                                <td class='t-c'>
                                  <button type="button"
                                          class="btn btn-xs btn-danger"
                                          @click="destroy(f.id)"
                                          title="Remover">
                                    <svg-icon icon="trash-alt"/>
                                  </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h4 v-else class="t-c">Não há arquivos</h4>
                    </div>
                </div>

            </div>
        </template>

        <template v-slot:footer>
            <button type="button"
                    @click="closeModal()"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>
    </modal>
</template>

<script>
    import {CustomerGroup} from "../../model";
    import {SHOW_CUSTOMER_GROUP_FILE, EventBus} from "../../utils/EventBus";
    const baseUrl = '/v1/customer_group_files'

    export default {
        name: "ModalCustomerGroupFiles",
        components: {
            FileUpload: () => import(/* webpackChunkName: "comp-file-upload" */ '@/components/FileUpload')
        },
        data() {
            return {
                showModal: false,
                modalMode: 'edit',
                percent: 10,
                customer_group_id: null,
                customer_groups: [],
                accept_files: [],
                files: [],
                timer: null,
                bucket_size: ''
            }
        },
        methods: {
            changeCustomerGroup() {
                this.files = [];

                if (this.customer_group_id) {
                    this.$appHttp.get(`${baseUrl}/search_customer_group_files/${this.customer_group_id}`)
                        .then(({data}) => {
                            this.files.push(...data)
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();
                            console.error('Load files group fail', err);
                        })
                }
            },
            download(id) {
                this.$appHttp.get(`${baseUrl}/download/${id}`)
                    .then(({data}) => {
                        document.location.href = data.url;
                    })
                    .catch(console.error)
            },
            fileUploaded(data) {
                this.files.splice(0, 0, data.response);
                this.bucketSize()
            },
            bucketSize() {
                this.$appHttp.get('${baseUrl}/bucket_size')
                    .then(({data}) => {
                        this.bucket_size = data.size_text;
                    })
                    .catch(console.error)
            },
            closeModal() {
              if (this.callbackModal) this.callbackModal();
              this.showModal = false;
            },
            destroy(idItem) {
              this.$store.commit('addModal', {title: this.$t('common.destroyItemTitle'), size: 'small', body: this.$t('common.destroyItemMessage'), buttons: [
                  {type: 'ok', class: 'btn btn-danger btn-sm', method: id => {
                      this.$store.commit('destroyModal', id);
                      this.$appHttp.delete(`${baseUrl}/destroy/${idItem}`)
                          .then(() => this.$set(this, 'files', this.files.filter(f => f.id !== idItem)))
                          .catch(console.error)
                    }},
                  {type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)}
                ]})
            }
        },
        mounted() {
            EventBus.$on(SHOW_CUSTOMER_GROUP_FILE, options => {
                this.modalMode = options.mode || 'edit';
                this.callbackModal = options.callback;
                this.customer_group_id = options.customer_group_id ? options.customer_group_id : null;

                this.$appHttp.get('/v1/customer_group_files/accept_files')
                    .then(({data}) => {
                        this.accept_files.push(...data);
                    })
                    .catch(err => {
                        console.error('Fail to load accepted file types', err);
                    });

                CustomerGroup.all('count')
                    .then(data => {
                        data.forEach(f => this.customer_groups.pushOrChange(f))
                    })
                    .catch(err => {
                        this.$appUtils.vibrate();
                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar carregar os grupos...'}), this.$appStorage.getUser().name);
                        console.error(err);
                    });

                this.changeCustomerGroup();
                this.bucketSize();

                this.showModal = true;
            })
        },
        computed: {
            modalTitle() {
                return 'Controle de Arquivos' + (this.bucket_size ? ` (${this.bucket_size})` : '');
            }
        }
    }
</script>

<style scoped>

</style>
